import {AuthorizationSteps} from 'features/auth/ui/AuthorizationSteps';
import {FC} from 'react';

export const LoginPage: FC = () => {
	return <AuthorizationSteps />;
};
